<template lang="pug">
div.itlp-checkout-input(v-if='key && !skip' :class="{'itlp-input-has-error': hasError, 'itlp-input-required': inputAttrs.required}")
	label(:for='inputId' :class='classes.label') {{label}}
	input(:id='inputId' :class='classes.input' type='date' v-model='props.controller.value.value' v-bind="inputAttrs")
</template>

<script setup lang='ts'>
import { computed } from 'vue';
import type { PropType } from 'vue';
import type {InputController} from '@/apps/checkout/composables/useForm';

const props = defineProps({
	controller: {
		type: Object as PropType<InputController>,
		required: true
	}
});

const {key, label, hasError, skip, inputAttrs} = props.controller;

const classes = computed(() => {
	return {
		label: {},
		input: {}
	}
});

const inputId = computed(() => {
	return key+'_'+String(Math.floor(Math.random() * 1000000))
});

</script>

<style>
.itlp-checkout-input{
	display: flex;
	flex-direction: column;
}
</style>